import { createStyles, makeStyles } from '@material-ui/styles';
import * as React from 'react';
import { FC } from 'react';
import mediaQueries from 'src/constants/responsive';
import spacing from 'src/constants/spacing';

const useStyles = makeStyles(() =>
	createStyles({
		videoContainer: {
			width: `100%`,
			[mediaQueries.Mobile]: {
				paddingLeft: spacing.GutterGrid.Mobile / 2,
				paddingRight: spacing.GutterGrid.Mobile / 2,

				paddingBottom: spacing.Gutter.Mobile / 2,
			},
			[mediaQueries.Tablet]: {
				paddingLeft: spacing.GutterGrid.Tablet / 2,
				paddingRight: spacing.GutterGrid.Tablet / 2,

				paddingBottom: spacing.Gutter.Tablet / 2,
			},
			[mediaQueries.Laptop]: {
				paddingLeft: spacing.GutterGrid.Laptop / 2,
				paddingRight: spacing.GutterGrid.Laptop / 2,

				paddingBottom: spacing.Gutter.Laptop / 2,
			},
			[mediaQueries.Desktop]: {
				paddingLeft: spacing.GutterGrid.Desktop / 2,
				paddingRight: spacing.GutterGrid.Desktop / 2,

				paddingBottom: spacing.Gutter.Desktop / 2,
			},
			[mediaQueries.BigDesktop]: {
				width: `${(2 / 3) * 100}%`,
				marginLeft: 'auto',
				paddingLeft: spacing.GutterGrid.BigDesktop / 2,
				paddingRight: spacing.GutterGrid.BigDesktop / 2,

				paddingBottom: spacing.Gutter.BigDesktop / 2,
			},
		},
		iframeContainer: {
			position: 'relative',
			height: 0,
			paddingBottom: '56.25%',
		},
		iframe: {
			position: 'absolute',
			top: 0,
			left: 0,
			border: 0,
			width: '100%',
			height: '100%',
		},
	})
);

export type PanelVideo = PanelVideoDto;

type Props = PanelVideo;

const PanelVideo: FC<Props> = (props) => {
	const cls = useStyles();
	const {
		children,
		Video: { Id, Provider },
	} = props;

	return (
		<div className={cls.videoContainer}>
			<div className={cls.iframeContainer}>
				{Provider === 'youtube' && (
					<iframe
						className={cls.iframe}
						src={`https://www.youtube.com/embed/${Id}?rel=0`}
					/>
				)}
				{Provider === 'vimeo' && (
					<iframe
						className={cls.iframe}
						src={`https://player.vimeo.com/video/${Id}?title=0&byline=0&portrait=0`}
					/>
				)}
			</div>
			{children}
		</div>
	);
};

export default PanelVideo;



// WEBPACK FOOTER //
// ./src/Components/Panels/PanelVideo.tsx